(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-mobile-menu"] && !Shopify.designMode) return;
  try {
    // Revision round 2: the product rail's auto-drift is GONE (client: "stop
  // the scrolling movement") — the carousel sits still and moves only when
  // the visitor swipes it.

  // Category tabs -> swap the carousel panel + point the CTA at the tab's collection.
  document.addEventListener("click", function (e) {
    var tab = e.target.closest(".mmenu__tab");
    if (!tab) return;
    var idx = tab.getAttribute("data-mmenu-tab");
    tab.closest("[data-mmenu-tabs]").querySelectorAll(".mmenu__tab").forEach(function (t) {
      t.classList.toggle("is-active", t === tab);
    });
    var menu = tab.closest(".mmenu");
    if (!menu || idx === null) return;
    var activePanel = null;
    menu.querySelectorAll("[data-mmenu-panel]").forEach(function (p) {
      var on = p.getAttribute("data-mmenu-panel") === idx;
      p.hidden = !on;
      if (on) activePanel = p;
    });
    var cta = menu.querySelector("[data-mmenu-cta]");
    if (cta && activePanel && activePanel.getAttribute("data-cta-url")) {
      cta.setAttribute("href", activePanel.getAttribute("data-cta-url"));
    }
  });

  // Dropdown rows (Shop by Category, +Shop and the nested Lifestyle ones).
  // 2026-10-14: only ONE dropdown open at a time — opening one closes any
  // other open dropdown, except the one it sits inside (so Everyday stays
  // open while Tops opens inside it). Closing a dropdown also closes
  // anything open inside it, so it's tidy the next time it opens.
  function mmenuCloseAcc(btn) {
    var sub = btn.nextElementSibling;
    if (sub && sub.classList.contains("mmenu__sub")) {
      sub.hidden = true;
      sub.querySelectorAll('[data-mmenu-acc][aria-expanded="true"]').forEach(function (inner) {
        var innerSub = inner.nextElementSibling;
        if (innerSub && innerSub.classList.contains("mmenu__sub")) innerSub.hidden = true;
        inner.setAttribute("aria-expanded", "false");
      });
    }
    btn.setAttribute("aria-expanded", "false");
  }
  document.addEventListener("click", function (e) {
    var acc = e.target.closest("[data-mmenu-acc]");
    if (!acc) return;
    var sub = acc.nextElementSibling;
    if (!sub || !sub.classList.contains("mmenu__sub")) return;
    var opening = sub.hidden;
    if (opening) {
      var scope = acc.closest(".mmenu") || document;
      scope.querySelectorAll('[data-mmenu-acc][aria-expanded="true"]').forEach(function (other) {
        if (other === acc) return;
        var otherSub = other.nextElementSibling;
        // keep the dropdown this one lives inside
        if (otherSub && otherSub.contains(acc)) return;
        mmenuCloseAcc(other);
      });
      sub.hidden = false;
      acc.setAttribute("aria-expanded", "true");
    } else {
      mmenuCloseAcc(acc);
    }
  });

  // Warm the hidden panels' images once the browser is idle so tab switches
  // never flash the tile background while a photo fetches.
  function mmenuPreload() {
    document.querySelectorAll('.mmenu [data-mmenu-panel] img[loading="lazy"]').forEach(function (img) {
      img.setAttribute("loading", "eager");
    });
  }
  if (window.matchMedia("(max-width: 989px)").matches) {
    if ("requestIdleCallback" in window) { requestIdleCallback(mmenuPreload, { timeout: 4000 }); }
    else { setTimeout(mmenuPreload, 2500); }
  }

  // Swatch hover/press -> swap the card photo to that color's variant image.
  function mmenuSwatchSwap(sw) {
    var card = sw.closest("[data-swatch-card]");
    if (!card) return;
    var photo = card.querySelector(".mmenu__card-img img");
    var src = sw.getAttribute("data-swatch-img");
    if (photo && src && photo.getAttribute("src") !== src) {
      photo.removeAttribute("srcset");
      photo.setAttribute("src", src);
    }
    sw.parentNode.querySelectorAll(".mmenu__swatch").forEach(function (s) {
      s.classList.toggle("is-active", s === sw);
    });
  }
  document.addEventListener("mouseover", function (e) {
    var sw = e.target.closest(".mmenu__swatch[data-swatch-img]");
    if (sw) mmenuSwatchSwap(sw);
  });
  document.addEventListener("click", function (e) {
    var sw = e.target.closest(".mmenu__swatch[data-swatch-img]");
    if (sw) { e.preventDefault(); e.stopPropagation(); mmenuSwatchSwap(sw); }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Enter" && e.key !== " ") return;
    var sw = e.target.closest ? e.target.closest(".mmenu__swatch[data-swatch-img]") : null;
    if (sw) { e.preventDefault(); mmenuSwatchSwap(sw); }
  });
  } catch(e) { console.error(e); }
})();

})();
